import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider as MainProvider } from "./Context/dataContext";
import { ProviderAuth as AuthProvider } from "./Context/userContext";

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID

ReactDOM.render(
  <GoogleOAuthProvider clientId={CLIENT_ID}>
    <AuthProvider>
      <MainProvider>
        <App />
      </MainProvider>
    </AuthProvider>
  </GoogleOAuthProvider>,

  document.getElementById("root")
);
